export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_PERMANENT =
  'docFlowSendingEmailSettingsPermanentNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_UNAVAILABLE =
  'docFlowSendingEmailSettingsUnavailableNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_ERROR =
  'docFlowSendingEmailSettingsErrorNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_SUCCESS =
  'docFlowSendingEmailSettingsSuccessNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_RECIPIENTS_IN_BLACK_LIST_ERROR =
  'docFlowSendingEmailSettingsrecipientsInBlackListErrorNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_REQUIRED_FIELDS =
  'docFlowSendingEmailSettingsRequiredFieldsNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_ERROR_UNABLE_ACCOUNT =
  'Account_is_not_available_for_user'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_RECIPIENTS_WITHOUT_EMAIL_ERROR =
  'docFlowSendingEmailSettingsrecipientsWithoutEmailErrorNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_NOTIFICATION_ID_AI_DRAFT =
  'docFlowSendingEmailSettingsAIDraftNotAppliedNotification'

export const DOC_FLOW_SENDING_EMAIL_SETTINGS_SERVER_NON_FIELD_ERRORS = {
  [DOC_FLOW_SENDING_EMAIL_SETTINGS_ERROR_UNABLE_ACCOUNT]:
    'DocumentStapling.UnableAccountForUserKey',
}
